import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import SessionExpiredPopup from '../../../components/MultiAppAuthentication/SessionExpiredPopup';

const mapStateToProps = (state: StoreState) => {
	const { multiAppAuthenticationInfos: { isSessionExpired } } = state;
	return {
		isDisplayed: isSessionExpired,
	};
};

export default connect(mapStateToProps)(SessionExpiredPopup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/SessionExpiredPopup/index.tsx